// Default document-date window for the AR Automation data tables
// (Customer PO, Sale Order, File Tracking).
//
// Why this exists: those tables used to open with an empty date filter, so the
// page subscribed to the company's entire `PurchaseOrders` /
// `PurchaseFileTracks` collection. Every entry point that seeds or resets a
// filter card goes through here so a list cannot fall back to an unbounded
// query by accident. Same rationale as `docDateRange.js`, which does this for
// the ThaiSmartTax lists.
//
// The window is the current month plus the two before it — opened on
// 10 Sep 2026 it reads 2026-07-01 → 2026-09-10. Unlike the ThaiSmartTax
// window this one is closed on both sides: every consumer here treats a
// missing end date as "same day as the start" (`searchEndDate ? ... : new
// Date(searchStartDate)`), so an open-ended default would collapse the filter
// to a single day instead of widening it.

import moment from "moment-timezone";

const DATE_FORMAT = "YYYY-MM-DD";

// Documents are stamped against the Thai business day regardless of where the
// viewer's browser sits, so the window is anchored to Bangkok.
const TZ = "Asia/Bangkok";

// Whole months before the current one that the default window starts at.
// 2 = a three-month window counting the current month.
export const DEFAULT_MONTHS_BACK = 2;

// Default range as the `YYYY-MM-DD` strings the date pickers bind to.
export function getDefaultArDateRange() {
  const today = moment().tz(TZ);
  return {
    fromDate: today
      .clone()
      .subtract(DEFAULT_MONTHS_BACK, "months")
      .startOf("month")
      .format(DATE_FORMAT),
    toDate: today.format(DATE_FORMAT),
  };
}
